<div class="compact padded">
    <ng-container *ngIf="pageReady">
        <div id="breadcrumbs">
            <span><a routerLink="/{{currentLang.defended ? '' : currentLang.slug}}">{{currentLang.s['common']['home']}}</a></span>
        </div>
        <h1 [innerHTML]="page.h1[currentLang.slug] || page.name[currentLang.slug]"></h1>
        <div class="content" [innerHTML]="page.content[currentLang.slug]"></div>
    </ng-container>
</div>
